<template>
  <v-container>
    <v-toolbar flat>
      <v-toolbar-title>{{ $t("headings.survey-answers") }}</v-toolbar-title>
      <v-spacer> </v-spacer>
    </v-toolbar>
    <v-row class="table-row" v-for="answer in answers" :key="answer.id">
      <v-col cols="12"
        ><p>{{ $t("label.question") }} : {{ answer.question }}</p></v-col
      >
      <hr />
      <v-col cols="12">
        <p>{{ $t("label.answer") }} : {{ answer.answer }}</p>
        <v-divider></v-divider>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { IndexData } from "@/helpers/apiMethods";

export default {
  data() {
    return {
      answers: null,
    };
  },
  methods: {
    handleShowData() {
      IndexData({
        reqName: `survey-forms/${this.$route.params.id}/answers`,
      })
        .then((res) => {
          this.answers = res.data.data;
        })
        .catch((err) => console.log(err));
    },
  },
  mounted() {
    this.handleShowData();
  },
};
</script>

<style></style>
